<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  created() {
    this.modelChange()
  },
  methods: {
    // 使用方法
    async modelChange() {
      let detail = await this.service.User.PlatformSetting({
        pageNo: 1,
        pageSize: 10,
        dictType: "9",
      });
      if (detail.code == 0) {
        document.title = detail.data[0].fullName;
        configureInfos.domainName = detail.data[0].domain;
        configureInfos.OSSDomain = detail.data[0].ossDomainName;
        configureInfos.recordNo = detail.data[0].domainNumber;
        configureInfos.logo = detail.data[0].logo;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.is-vertical {
  height: 100%;
}

body > .el-container {
  height: 100%;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue